import { Box } from '@mui/material';
import icons from './icons';
import palette from './pallete';

export interface CategoryIconProps {
  icon?: string;
  color?: string;
  size?: 'small' | 'medium' | 'large';
}

const sizeValue = {
  small: 25,
  medium: 30,
  large: 50
};

const CategoryIcon = ({
  icon = 'wallet',
  color = 'white',
  size = 'large'
}: CategoryIconProps) => {
  const Icon = icons[icon] ?? icons['wallet'];
  const selectedColor = palette[color] ?? palette['white'];
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 1,
        width: sizeValue[size],
        height: sizeValue[size],
        borderRadius: 5,
        backgroundColor: selectedColor.color,
        border: `1px solid ${color === 'white' ? '#ddd' : selectedColor.color}`
      }}
    >
      <Icon
        fontSize={size}
        sx={{
          color:
            selectedColor.fontColor === 'black'
              ? '#333'
              : selectedColor.fontColor
        }}
      />
    </Box>
  );
};

export default CategoryIcon;
